import { useState, useRef, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import debounce from 'lodash/debounce'
import { Input } from 'reactstrap'

import { setPdl, getPdl } from 'store/invoices/selection'
import { FormGroup } from 'library'

const PdlInput= () => {
  const dispatch = useDispatch()
  const pdl = useSelector(getPdl)
  const [value, setValue] = useState(pdl)
  const debounced = useRef(
    debounce((x: any) => {
      dispatch(setPdl(x))
    }, 400)
  )

  useEffect(() => {
    if (pdl !== value) {
      debounced.current(value)
    }
  }, [pdl, value])

  return (
    <FormGroup label="Compteur">
      <Input
        type="search"
        value={value || ''}
        onInput={(e: any) => setValue(e.target.value)}
        onChange={() => {}}
        style={{ fontSize: 14 }}
      />
    </FormGroup>
  )
}

export default PdlInput
